// TODO: вынести в компоненты модуля, так как fsd widgets не должен управлять состоянием

import { ButtonWithIcon } from '@ui/button';
import classNames from 'classnames';
import { useStore } from 'effector-react';
import { simpleMix } from '@entities/simple-mix';
import { StrictMode, useCallback, useEffect, useId, useRef } from 'react';
import {
  $showZoomButton,
  $zoomModeEnabled,
  mapLoaded,
  toggleZoomMode,
  $contextMenuEnabled,
  $contextMenuCoords,
  closeContextMenu,
  $contextMenuStatus,
  toggleLeftWh,
  toggleRightWh,
  selectSleeve,
} from '../model';
import { map } from './model';
import styles from './styles.module.css';
import { ContextMenu } from '@consta/uikit/ContextMenu';
import {
  $agricultureById,
  $copiedBagParamsBuffer,
  copyAgricultureModal,
  copySleeveParams,
  editAgricultureModal,
  showFillModal,
} from '@@/agriculture/store/agriculture.store';
import { emptyBag, mixBag, removeBag, unmixBag } from '@features/edit-bag/model';
import { useBag } from '@entities/warehouse/store';
import { useNavigate } from 'react-router';
import { warehouseModel } from '@/entities/warehouse';
import { removeBag as removeBagEvent } from '@/entities/simple-mix/model';
import { copyBag } from '@/modules/bags/functions/copy-bag.function';
import {
  $isSubscribed,
  // switchDisplayBuySubscription,
} from '@/modules/auth/store/auth.store';

export const WarehouseMap = ({ className = '' }) => {
  const showZoomButton = useStore($showZoomButton);
  const navigate = useNavigate();
  const zoomModeEnabled = useStore($zoomModeEnabled);
  const contextMenuEnabled = useStore($contextMenuEnabled);
  const contextMenuStatus = useStore($contextMenuStatus);
  const contextMenuCoords = useStore($contextMenuCoords);
  const agricultureById = useStore($agricultureById);
  const mixedBagsCount = useStore(simpleMix.$mixedBagsCount);
  const selectedWarehouse = useStore(warehouseModel.$warehouseInfo);
  const copiedBagParamsBuffer = useStore($copiedBagParamsBuffer);
  // const isSubscribed = useStore($isSubscribed);
  const { MAX_SIMPLE_MIXING_ITEMS_CNT } = simpleMix;
  const ctxmRef = useRef(null);
  const containerDomRef = useRef<HTMLDivElement>(null);
  let animationFrame: number = 0;
  const observerRef = useRef(
    new ResizeObserver(() => {
      if (animationFrame) {
        window.cancelAnimationFrame(animationFrame);
        animationFrame = 0;
      }
      animationFrame = window.requestAnimationFrame(() => {
        map.resize();
      });
    }),
  );

  useEffect(() => {
    ymaps.ready(() => {
      map.init('yviewer', containerDomRef.current);
      mapLoaded();
    });

    if (containerDomRef.current) {
      observerRef.current.observe(containerDomRef.current);
    }

    return () => {
      map.dispose();
      observerRef.current.disconnect();
    };
  }, []);

  const items = [];

  if (contextMenuEnabled) {
    const bag = useBag(contextMenuEnabled.id);
    if (bag.agricultureId && !copiedBagParamsBuffer) {
      items.push({
        id: 2,
        label: 'копировать параметры',
        onClick: () => copySleeveParams({ bag }),
      });
    }

    if (simpleMix.isBagMixed(bag.id)) {
      items.push({
        label: 'удалить из бункера',
        onClick: () => {
          if (localStorage.getItem('R_BAG') === bag.id) {
            toggleRightWh(null);
            removeBagEvent('right');
            localStorage.removeItem('bag_b_initial_state');
            localStorage.removeItem('bagB');
          } else if (localStorage.getItem('L_BAG') === bag.id) {
            toggleLeftWh(null);
            removeBagEvent('left');
            localStorage.removeItem('bag_a_initial_state');
            localStorage.removeItem('bagA');
          }
          unmixBag({ bagId: bag.id });
          map.markSleeve(bag);
        },
      });
    } else if (!bag.agricultureId) {
      items.push(
        {
          id: 11,
          label: 'заполнить',
          onClick: () => {
            showFillModal(contextMenuEnabled);
          },
        },
        // {
        //   id: 12,
        //   label: 'удалить',
        //   onClick: () => {
        //     removeBag({ bagId: contextMenuEnabled.id, warehouseId: 0 });
        //   },
        // },
      );
      if (
        copiedBagParamsBuffer &&
        selectedWarehouse &&
        selectedWarehouse.id === copiedBagParamsBuffer.warehouseId
      ) {
        items.unshift({
          id: 10,
          label: 'вставить параметры',
          onClick: async () => {
            copyBag({ bag: copiedBagParamsBuffer, adressId: bag.id });
          },
        });
      }
    } else {
      if (
        PUBLIC_MODE !== 'production' &&
        agricultureById[bag.agricultureId as number]?.mixable &&
        mixedBagsCount < MAX_SIMPLE_MIXING_ITEMS_CNT
      ) {
        items.push({
          id: 0,
          label: 'замиксовать',
          onClick: () => {
            //if (isSubscribed === false) return switchDisplayBuySubscription(true);
            mixBag({ bagId: bag.id });
            const state = {
              weight: bag.weight,
              gluten: bag.values.find((item) => item.name === 'Клейковина')?.value,
              idk: bag.values.find((item) => item.name === 'ИДК')?.value,
              bug: 0, // WARNING
              protein: bag.values.find((item) => item.name === 'Протеин')?.value,
              cp: bag.values.find((item) => item.name === 'Число падения')?.value,
              nature: bag.values.find((item) => item.name === 'Натура')?.value,
              humidity: bag.values.find((item) => item.name === 'Влажность культуры')
                ?.value,
            };

            if (localStorage.getItem('L_BAG') === bag.id) {
              selectedWarehouse &&
                toggleLeftWh({
                  id: selectedWarehouse.id,
                  name: selectedWarehouse.name,
                } as any);
              localStorage.setItem('bagA', JSON.stringify(state));
              localStorage.setItem('bag_a_initial_state', JSON.stringify(state));
            } else if (localStorage.getItem('R_BAG') === bag.id) {
              selectedWarehouse &&
                toggleRightWh({
                  id: selectedWarehouse.id,
                  name: selectedWarehouse.name,
                } as any);
              //navigate('/mixing-simple');

              localStorage.setItem('bagB', JSON.stringify(state));
              localStorage.setItem('bag_b_initial_state', JSON.stringify(state));
              navigate('/calculator');
            }
            map.markSleeve(bag, true);
          },
        });
      }
      items.push(
        {
          id: 1,
          label: 'дублировать',
          onClick: () => {
            copyAgricultureModal({ bagId: contextMenuEnabled.id });
          },
        },
        {
          id: 3,
          label: 'редактировать',
          onClick: () => {
            editAgricultureModal(contextMenuEnabled);
          },
        },

        {
          id: 4,
          label: 'опустошить',
          onClick: () => {
            emptyBag({ bagId: contextMenuEnabled.id, warehouseId: 0 });
          },
        },
      );
    }
  }
  //   document.addEventListener('mousemove', function (e) {
  //     console.log(`Позиция мыши: ${e.clientX}, ${e.clientY}`);
  //   });
  const handleCloseContextMenu = useCallback(() => {
    if (contextMenuStatus) {
      closeContextMenu();
    }
  }, [contextMenuStatus]);

  useEffect(() => {
    document.addEventListener('mousedown', handleCloseContextMenu);
    document.addEventListener('wheel', handleCloseContextMenu);

    return () => {
      document.removeEventListener('mousedown', handleCloseContextMenu);
      document.removeEventListener('wheel', handleCloseContextMenu);
    };
  }, [handleCloseContextMenu]);
  return (
    <StrictMode>
      <figure className={classNames([styles.map, className])}>
        <div className={styles.container} id="yviewer" ref={containerDomRef} />
        {showZoomButton && (
          <ButtonWithIcon
            icon="ZoomIcon"
            title={zoomModeEnabled ? 'Выключить ZOOM' : 'Включить ZOOM'}
            data-disabled={!zoomModeEnabled}
            className={styles.zoomButton}
            onClick={() => toggleZoomMode(!zoomModeEnabled)}
          />
        )}
      </figure>

      <ContextMenu
        className={styles.contextMenu}
        style={{
          top: contextMenuCoords[1],
          left: contextMenuCoords[0],
          borderTopLeftRadius: 0,
        }}
        items={items.sort((a: any, b: any) => a.id - b.id)}
        anchorRef={ctxmRef}
        isOpen={contextMenuStatus}
        onClick={() => closeContextMenu()}
      />
    </StrictMode>
  );
};
